import React, { FC, ReactNode } from "react";
import { Box, withStyles } from "@material-ui/core";

interface DarkFlowerWrapperProps {
  children: ReactNode;
  disablePaddingBottom?: boolean;
}

const StyledBox = withStyles(() => ({
  root: {
    minHeight: 'calc(100vh + 70px)',
    overflow: 'hidden',
    paddingBottom: ({ disablePaddingBottom }: Partial<DarkFlowerWrapperProps>) =>
      disablePaddingBottom ? 0 : 70,
  },
}))(Box);

const DarkFlowerWrapper: FC<DarkFlowerWrapperProps> = ({
  children,
  disablePaddingBottom = false,
}) => <StyledBox disablePaddingBottom={disablePaddingBottom}>{children}</StyledBox>;

export default DarkFlowerWrapper;
